import SubmitScTracking from "./scTracking";

export const scTrackOnClick = {
    init: () => {

        const trackingLinks = document.querySelectorAll(".sd-sc-track-goals");

        if (trackingLinks) {
            new SubmitScTracking(trackingLinks);
      }
    }
}

export default scTrackOnClick;